namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_app_overlay, {

		background: {
			color: 'transparent',
		},
		justify: {
			content: 'center',
		},
		position: 'fixed',
		pointerEvents: 'none',
		bottom: 0,
		width: '100%',
		zIndex: 6,

		borderStyle: 'none',
		borderWidth: '0px',
		padding: 0,
		height: '100vh',

		Overlayed_map_holder: {
			position: 'absolute',
			inset: '0',
			pointerEvents: 'none',
		},

		Quick_access: {
			position: 'absolute',
			bottom: '1rem',
		},

		Fullscreen_panel: {
			position: 'fixed',
			right: 0,
			top: 0,
			zIndex: 7,
			pointerEvents: 'auto',
		},
		
	} )
	
}
